/**
 * Do not edit directly!
 * Changes will be overriden by Style Dictionary.
 */

module.exports = {
  "border": {
    "width": {
      "thin": "1px",
      "medium": "2px",
      "thick": "4px"
    },
    "radius": {
      "small": "0.125rem",
      "medium": "0.25rem",
      "large": "0.5rem",
      "full": "8rem"
    }
  },
  "breakpoints": {
    "s": 321,
    "m": 768,
    "l": 1024,
    "xl": 1280,
    "xxl": 1440
  },
  "color": {
    "brand": {
      "primary": {
        "default": "#002d72",
        "tint": {
          "10": "#1a4280",
          "20": "#33578e",
          "30": "#4d6c9c",
          "40": "#6681aa",
          "50": "#8096b9",
          "60": "#99abc7",
          "70": "#b3c0d5",
          "80": "#ccd5e3",
          "90": "#e6eaf1",
          "95": "#f2f5f8"
        },
        "shade": {
          "10": "#002967",
          "20": "#00245b",
          "30": "#002050",
          "40": "#001b44",
          "50": "#001739",
          "60": "#00122e",
          "70": "#000e22",
          "80": "#000917",
          "90": "#00050b"
        }
      },
      "secondary": {
        "default": "#ffed00",
        "tint": {
          "10": "#ffef1a",
          "20": "#fff133",
          "30": "#fff24d",
          "40": "#fff466",
          "50": "#fff680",
          "60": "#fff899",
          "70": "#fffab3",
          "80": "#fffbcc",
          "90": "#fffde6",
          "95": "#fffef2"
        },
        "shade": {
          "10": "#e6d500",
          "20": "#ccbe00",
          "30": "#b3a600",
          "40": "#998e00",
          "50": "#807700",
          "60": "#665f00",
          "70": "#4d4700",
          "80": "#332f00",
          "90": "#1a1800"
        }
      }
    },
    "contrast": {
      "black": "#000000",
      "white": "#ffffff"
    },
    "palette": {
      "red": {
        "default": "#de351b",
        "tint": {
          "10": "#e14932",
          "20": "#e55d49",
          "30": "#e8725f",
          "40": "#eb8676",
          "50": "#ef9a8d",
          "60": "#f2aea4",
          "70": "#f5c2bb",
          "80": "#f8d7d1",
          "90": "#fcebe8",
          "95": "#fdf5f4"
        },
        "shade": {
          "10": "#c83018",
          "20": "#b22a16",
          "30": "#9b2513",
          "40": "#852010",
          "50": "#6f1b0e",
          "60": "#59150b",
          "70": "#431008",
          "80": "#2c0b05",
          "90": "#160503"
        }
      },
      "yellow": {
        "default": "#ffed00",
        "tint": {
          "10": "#ffef1a",
          "20": "#fff133",
          "30": "#fff24d",
          "40": "#fff466",
          "50": "#fff680",
          "60": "#fff899",
          "70": "#fffab3",
          "80": "#fffbcc",
          "90": "#fffde6",
          "95": "#fffef2"
        },
        "shade": {
          "10": "#e6d500",
          "20": "#ccbe00",
          "30": "#b3a600",
          "40": "#998e00",
          "50": "#807700",
          "60": "#665f00",
          "70": "#4d4700",
          "80": "#332f00",
          "90": "#1a1800"
        }
      },
      "green": {
        "default": "#34c082",
        "tint": {
          "10": "#48c68f",
          "20": "#5dcd9b",
          "30": "#71d3a8",
          "40": "#85d9b4",
          "50": "#9ae0c1",
          "60": "#aee6cd",
          "70": "#c2ecda",
          "80": "#d6f2e6",
          "90": "#ebf9f3",
          "95": "#f5fcf9"
        },
        "shade": {
          "10": "#2fad75",
          "20": "#2a9a68",
          "30": "#24865b",
          "40": "#1f734e",
          "50": "#1a6041",
          "60": "#154d34",
          "70": "#103a27",
          "80": "#0a261a",
          "90": "#05130d"
        }
      },
      "blue": {
        "default": "#0064fe",
        "tint": {
          "10": "#1a74fe",
          "20": "#3383fe",
          "30": "#4d93fe",
          "40": "#66a2fe",
          "50": "#80b2ff",
          "60": "#99c1ff",
          "70": "#b3d1ff",
          "80": "#cce0ff",
          "90": "#e6f0ff",
          "95": "#f2f7ff"
        },
        "shade": {
          "10": "#005ae5",
          "20": "#0050cb",
          "30": "#0046b2",
          "40": "#003c98",
          "50": "#00327f",
          "60": "#002866",
          "70": "#001e4c",
          "80": "#001433",
          "90": "#000a19"
        }
      },
      "grey": {
        "default": "#001432",
        "tint": {
          "10": "#1a2c47",
          "20": "#33435b",
          "30": "#4d5b70",
          "40": "#667284",
          "50": "#808a99",
          "60": "#99a1ad",
          "70": "#b3b9c2",
          "80": "#ccd0d6",
          "90": "#e6e8eb",
          "95": "#f2f3f5"
        },
        "shade": {
          "10": "#00122d",
          "20": "#001028",
          "30": "#000e23",
          "40": "#000c1e",
          "50": "#000a19",
          "60": "#000814",
          "70": "#00060f",
          "80": "#00040a",
          "90": "#000205"
        }
      }
    },
    "danger": "#de351b",
    "attention": "#ffed00",
    "success": "#24865b",
    "interaction": "#0064fe",
    "neutral": "#001432",
    "muted": "#667284",
    "disabled": "#99a1ad",
    "inverted": "#ffffff",
    "appBackground": "#f2f5f8"
  },
  "font": {
    "weight": {
      "normal": "400",
      "heavy": "900"
    },
    "stack": "Lato, sans-serif",
    "heading": {
      "intro": {
        "size": "4rem",
        "line-height": "5rem"
      },
      "h1": {
        "size": "2rem",
        "line-height": "2.5rem"
      },
      "h2": {
        "size": "1.25rem",
        "line-height": "1.5rem"
      },
      "h3": {
        "size": "1.125rem",
        "line-height": "1.5rem"
      },
      "h4": {
        "size": "1rem",
        "line-height": "1.5rem"
      },
      "h5": {
        "size": "0.8125rem",
        "line-height": "1.25rem"
      },
      "h6": {
        "size": "0.6875rem",
        "line-height": "1rem"
      }
    },
    "text": {
      "small": {
        "size": "0.8125rem",
        "line-height": "1.25rem"
      },
      "medium": {
        "size": "1rem",
        "line-height": "1.5rem"
      },
      "large": {
        "size": "1.125rem",
        "line-height": "1.5rem"
      }
    },
    "label": {
      "size": "0.8125rem",
      "line-height": "1.25rem"
    },
    "input": {
      "size": "1rem",
      "line-height": "1.5rem"
    },
    "title": {
      "size": "0.75rem",
      "line-height": "1rem"
    },
    "button": {
      "small": {
        "size": "0.8125rem",
        "line-height": "1.25rem"
      },
      "medium": {
        "size": "1rem",
        "line-height": "1.5rem"
      },
      "large": {
        "size": "1.125rem",
        "line-height": "1.5rem"
      }
    },
    "bottomNavigation": {
      "size": "0.625rem",
      "line-height": "0.75rem"
    }
  },
  "grid": {
    "margin": "0.75rem",
    "gutter": "0.75rem"
  },
  "shadow": {
    "color": "#001432",
    "alpha": 0.2,
    "small": {
      "default": "0 1px 3px 0",
      "hover": "0 2px 6px 0",
      "inner": "0 1px 3px 0"
    },
    "medium": {
      "default": "0 1px 4px 0",
      "hover": "0 2px 8px 0",
      "inner": "0 4px 8px 0"
    },
    "large": {
      "default": "0 1px 8px 0",
      "hover": "0 2px 16px 0"
    },
    "xx-large": {
      "default": "0 8px 32px 0"
    },
    "inverted": {
      "default": "0 -2px 6px 0"
    }
  },
  "spacing": {
    "none": "0",
    "xxx-small": "0.125rem",
    "xx-small": "0.25rem",
    "x-small": "0.5rem",
    "small": "0.75rem",
    "medium": "1rem",
    "large": "1.5rem",
    "x-large": "2rem",
    "xx-large": "3rem"
  }
};